import * as yup from 'yup'

export const createSourceValidator = yup.object().shape({
  name: yup.string().required('Name is a required field'),
  integrationId: yup
    .string()
    .required('An integration is required while adding a source.'),
})
